import { render, staticRenderFns } from "./EntranceStudentHistoryHeader.vue?vue&type=template&id=4342d349&scoped=true&lang=pug&"
import script from "./EntranceStudentHistoryHeader.vue?vue&type=script&lang=ts&"
export * from "./EntranceStudentHistoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EntranceStudentHistoryHeader.vue?vue&type=style&index=0&id=4342d349&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4342d349",
  null
  
)

export default component.exports